module.exports = __webpack_public_path__ + "static/media/DT-LOGO-2022.c9beb383.png";